import { useSelector } from "react-redux";
import type { RootState } from "@/core/store.ts";

const useAppSelector = useSelector.withTypes<RootState>();

export default useAppSelector;
